import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "showBreezeIcon"];
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import { getStyledAIButton } from './styledButtons/StyledAIBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AIBaseButton(_ref) {
  let {
      children,
      showBreezeIcon = true
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const useOverride = uiButtonProps.use === BREEZE_SPECIAL ? undefined : uiButtonProps.use;

  // eslint-disable-next-line react-hooks/static-components
  const AIButtonComponent = getStyledAIButton(uiButtonProps.use);
  const {
    tokenProps,
    restProps
  } = filterTokenProps(uiButtonProps);
  const cssProps = useMapTokenPropsToCSS(tokenProps);
  const buttonProps = Object.assign({
    cssstyles: cssProps || {}
  }, restProps, useOverride !== undefined && {
    use: useOverride
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react-hooks/static-components
    _jsxs(AIButtonComponent, Object.assign({}, buttonProps, {
      children: [showBreezeIcon && /*#__PURE__*/_jsx(BreezeSingleStarIcon, {
        alignWithText: true
      }), children]
    }))
  );
}